<template>
    <v-form>
        <v-layout row>
            <v-flex xs12 sm4>
                <v-text-field
                    label="amount"
                    type="number"
                    v-model="amount"
                    required
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
                <v-text-field
                    label="project"
                    v-model="project"
                    required
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
                <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                >
                    <v-text-field
                        slot="activator"
                        label="Select Income Date"
                        v-model="paymentDate"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker v-model="paymentDate" title="Income Date" scrollable autosave></v-date-picker>
                </v-menu>
            </v-flex>
        </v-layout>
        <div class="spacer"></div>
        <v-btn :disabled="isDisabled()" @click.prevent="submit">Submit</v-btn>
    </v-form>
</template>

<script>
    import { Api } from '../../../../services/';
    import _ from 'lodash';

    export default {
        data() {
            return {
                amount: null,
                project: null,
                paymentDate: null,
                menu: null,
                payments: []

            }
        },

        methods: {
            submit() {
                let params = {
                    amount: this.amount,
                    project: this.project,
                    date: this.paymentDate
                };

                return Api.Payments().post(params);
            },

            isDisabled() {
                if (!_.isEmpty(this.amount) && !_.isEmpty(this.project) && !_.isEmpty(this.paymentDate)) {
                    return false;
                }

                return true;
            }
        },
        mounted() {
            return Api.Payments().get()
                .then(response => {
                    console.log('response:', response);
                });
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Components/Forms/PaymentForm.vue